import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>Page Not Found | BotSpot</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="notfound-container" role="main">
        <p className="notfound-heading" aria-hidden="true">
          404
        </p>
        <h1 className="notfound-title">Page Not Found</h1>
        <p className="notfound-text">
          Oops! Looks like you took a wrong turn into the void. The link you followed does not exist
          here. Time to blast off back home!
        </p>
        <Link to="/" className="cta-button">
          Blast Off Home
        </Link>
        <p className="notfound-links">
          <Link to="/challenges">Challenges</Link>
          {' · '}
          <Link to="/courses/ai-trading-bootcamp">Bootcamp</Link>
          {' · '}
          <Link to="/pricing">Pricing</Link>
        </p>
      </div>
    </>
  );
};

export default NotFound;
